module.exports = __webpack_public_path__ + "img/mashangjijian.3848677.svg";